export default {
      id: "eye-usage",
      viewBox: "0 0 490 490",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#eye-usage",
      toString: function () {
        return this.url;
      }
    }